import { extendTheme } from '@chakra-ui/react';
import { buttonTheme } from './variants';

const theme = extendTheme({
  colors: {
    navyBlue: '#00205B',
    navyBlueLight: '#19366B',
  },
  components: { Button: buttonTheme },
});

export default theme;
